import { render, staticRenderFns } from "./CaseOtherDetailsModal.vue?vue&type=template&id=9822d61e&scoped=true"
import script from "./CaseOtherDetailsModal.vue?vue&type=script&lang=js"
export * from "./CaseOtherDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./CaseOtherDetailsModal.vue?vue&type=style&index=0&id=9822d61e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9822d61e",
  null
  
)

export default component.exports